import 'css-chunksrc/client/scenes/folderCreation/styles.scss';export default {
  "group": "_group_1pz9b_1",
  "text": "_text_1pz9b_5",
  "name": "_name_1pz9b_10",
  "main": "_main_1pz9b_16",
  "buttons": "_buttons_1pz9b_23"
};